import { getHomepageContentUrl } from '../helpers/api';
import { getActiveLanguage, isLanguageHomePath } from '../helpers/homepageUrl';

export const HOMEPAGE_ASYNC_KEY = 'homepage';

const fetchHomepage = (url, helpers) => {
  if (helpers?.get) {
    return helpers.get(url);
  }

  return fetch(url, {
    headers: { Accept: 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Homepage fetch failed: ${response.status}`);
    }
    return response.json();
  });
};

export const loadHomepagePayload = (pathname, helpers) => {
  if (!isLanguageHomePath(pathname)) {
    return undefined;
  }

  const language = getActiveLanguage(pathname);
  return fetchHomepage(getHomepageContentUrl(language), helpers).then(
    (content) => ({ language, content }),
  );
};

export default function installHomepageAsyncProps(config) {
  const langs = (config.settings.supportedLanguages || ['ca']).join('|');

  config.settings.asyncPropsExtenders = [
    ...(config.settings.asyncPropsExtenders || []),
    {
      path: `/(${langs})`,
      exact: true,
      extend: (asyncItems = []) => {
        if (asyncItems.some((item) => item.key === HOMEPAGE_ASYNC_KEY)) {
          return asyncItems;
        }
        return [
          ...asyncItems,
          {
            key: HOMEPAGE_ASYNC_KEY,
            promise: ({ location, api, helpers }) =>
              loadHomepagePayload(location.pathname, api || helpers),
          },
        ];
      },
    },
  ];

  return config;
}
